/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import axios from 'axios';
import { MgmtPlaneClient } from '.';
import type { ApiRequestOptions } from './core/ApiRequestOptions';
import { BaseHttpRequest } from './core/BaseHttpRequest';
import type { CancelablePromise } from './core/CancelablePromise';
import type { OpenAPIConfig } from './core/OpenAPI';
import { request as __request } from './core/request';

let sessionExpired = false;

export function isSessionExpired() {
  return sessionExpired;
}

export function resetSessionExpired() {
  sessionExpired = false;
}

const axiosClient = axios.create();
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionExpired = true;
    }
    return Promise.reject(error);
  },
);

// AxiosHttpRequest is a class that extends BaseHttpRequest to provide a request method that uses our custom axios client.
class AxiosHttpRequest extends BaseHttpRequest {
  constructor(config: OpenAPIConfig) {
    super(config);
  }

  public override request<T>(options: ApiRequestOptions<T>): CancelablePromise<T> {
    return __request(this.config, options, axiosClient);
  }
}

export const mgmtPlaneAPIClient = new MgmtPlaneClient(
  {
    BASE: window.mimicConfig.MIMIC_MGMT_PLANE_API as string,
    WITH_CREDENTIALS: true,
  },
  AxiosHttpRequest,
);

export type PaginationParams = {
  number?: number;
  size?: number;
};
